var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexJC alignItem",staticStyle:{"margin-top":"50px"},attrs:{"id":"state"}},[_c('button',{staticClass:"btn-lx btn-lx-big mb10 btn-width",staticStyle:{"width":"300px"},on:{"click":function($event){return _vm.goTo()}}},[_vm._v("\n      请点击跳转到租借归还首页\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f64527d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/status.vue
// module id = null
// module chunks = 